import React from "react";
import EntityEmptyPage from "components/Records/NewRecordPages/EntityEmptyPage";
import AddEmailsPopup from "./AddEmailsPopup";


interface EmailsEmptyPageProps {
  onEmailsCreated?: (newEmails: any) => void;
}


export default function EmailsEmptyPage({
  onEmailsCreated,
}: EmailsEmptyPageProps) {
  return (
    <EntityEmptyPage
      title="Emails"
      colorKey="interactions"
      AddPopupComponent={AddEmailsPopup}
      onEntityCreated={onEmailsCreated}
      items={[
        {
          id: "select",
          type: "text",
          text: "Select an Email",
          direction: "left",
        },
        {
          id: "create",
          type: "button",
          label: "Create New Email",
          openPopup: true, 
        },
        {
          id: "send",
          type: "text",
          text: "Send Emails",
          direction: "right",
        },
        {
          id: "details",
          type: "text",
          text: "View Email History",
          direction: "down",
        },
      ]}
    />
  );
}
